<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let text;
</script>

<div class="button__wrapper headline-s" on:click={() => dispatch('click')}>
    {text}
</div>

<style>
    .button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 24px 40px;
        background: var(--black-100);
        color: var(--white-100);
        cursor: pointer;
        text-align: center;
    }
</style>
